import React from 'react';
import { AxiosError } from 'axios';
import CsReviewList from '../CsReviewList';
import useReactTable from '../../../../../hooks/common/useReactTable';
import FullscreenLoader from '../../../../../components/base/FullscreenLoader';
import { useFetchReviewsQuery } from '../../common/hook/queries/useFetchReviewsQuery';
import useReviewListExcelDownload from '../../common/hook/queries/useReviewListExcelDownload';
import toastMsg from '../../../../../lib/toastMsg';
import {
  CS_REVIEW_LIST_FILTER_OPTION_MODEL,
  CS_REVIEW_LIST_PAGINATION_MODEL,
  CS_REVIEW_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/review/models';
import { asyncSimpleModal } from '../../../../../lib/common';
import { extractErrorMessage } from '../../../../../lib/utils/checkErrorResponse';

const CsReviewListWrap = (): JSX.Element | null => {
  const {
    filterOption,
    paginationOption,
    sortOption,
    handleChangeFilterOption,
    handleChangePaginationOption,
    handleClickSortOption,
    handleClickResetFilter,
    currentPage,
    setCurrentPage,
    handleDateRangeChange,
  } = useReactTable({
    filterOptionModel: CS_REVIEW_LIST_FILTER_OPTION_MODEL,
    sortOptionModel: CS_REVIEW_LIST_SORT_OPTION_MODEL,
    paginationModel: CS_REVIEW_LIST_PAGINATION_MODEL,
  });

  const { data: reviewList, isLoading } = useFetchReviewsQuery({
    params: {
      page: Math.max(paginationOption.pageIndex, 1),
      pageSize: Math.max(paginationOption.pageSize, 100),
      ...filterOption,
      ...sortOption,
    },
  });

  const { mutateAsync } = useReviewListExcelDownload();

  const handleExcelDownload = async () => {
    try {
      const response = await mutateAsync({
        ...filterOption,
        ...sortOption,
      });
      if (response && response.adminEmail) {
        asyncSimpleModal({
          type: 'success',
          title: '엑셀 파일 요청 완료',
          message: `${response.adminEmail}로 엑셀파일을 받을 수 있는 링크를 전송하였습니다. 파일 크기에 따라 이메일 발송이 몇 분 소요될 수 있습니다.`,
        });
      }
    } catch (error) {
      toastMsg.error(extractErrorMessage(error as AxiosError));
    }
  };

  if (isLoading) {
    return <FullscreenLoader visible={true} />;
  }

  return (
    <CsReviewList
      reviewList={reviewList}
      onChangeFilterOption={handleChangeFilterOption}
      onClickResetFilter={handleClickResetFilter}
      onChangePaginationOption={handleChangePaginationOption}
      onClickExcelDownload={handleExcelDownload}
      onClickSortOption={handleClickSortOption}
      onClickDateRangeChange={handleDateRangeChange}
      paginationOption={paginationOption}
      sortOption={sortOption}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default CsReviewListWrap;
